import './VoicePopUp.less';
import { useRef, useCallback, useEffect, useContext, useState } from 'react';
// 导入自定义Icon组件
import Icon from '@/components/iconfont/Icon.jsx';
import { EditContext } from '@/context/EditContext';
// 导入播放和暂停图标
import ImgPlay from '@/assets/aivoices/play.svg';
import ImgPause from '@/assets/aivoices/pause.svg';

import ImgAiVoicePlay from '@/assets/edit/voice/play.svg';
import ImgAiVoicePause from '@/assets/edit/voice/pause.svg';
import ImgAdd from '@/assets/edit/voice/add.svg';
// 导入日期格式化工具函数
import { formatDateTime } from '@/utils/dayjs';
import PlayvoiceImg from '@/assets/aivoices/playvoice.gif';
// 导入空列表图片
import Imgnolist from '@/assets/empty/space.svg';
import { voiceController, projectController } from '@/api/edit';
import { useDrawer } from '@/hooks/DrawerHooks';
import { useWebSocket } from '@/hooks/useWebSocket.js';
import { MessageEventType } from '@/utils/socket.js';
import { useTranslation } from 'react-i18next';
import { EseClosePopup } from '@/hooks/useClosePopup';
// PopUp组件:包含多个弹窗组件
export default function VoicePopUp() {
  return <div className="VoicePopUp_box">{<VoiceBox />}</div>;
}

// NotificationPopUp组件:通知弹窗
function VoiceBox() {
  const { t } = useTranslation();
  const {
    showVoiceLost,
    setShowVoiceList,
    tabActive,
    setTabActive,
    selectVoiceItem,
    setSelectVoiceItem,
    userSubscription,
    useVoiceItem,
    setUseVoiceItem,
    updateTimestamp,
    setSpeakerList,
    currentItem,
    projectVoiceList,
    setProjectVoiceList,
    myVoiceList,
    setMyVoiceList,
    aiVoiceList,
    setAiVoiceList,
    setChangeVoiceEditSentence,
    selectSpeakerItem,
    voiceDeleteTime,
    mode,
  } = useContext(EditContext);
  // 创建对话框的引用
  const PopUpRef = useRef(null);

  // 处理关闭弹窗的回调函数
  const handleClose = useCallback(() => {
    setShowVoiceList(false);
  }, [setShowVoiceList]);
  useWebSocket(
    'RETRY_SUCCESS',
    useCallback(() => {
      getlist();
    }, []),
  );
  const getlist = useCallback(async () => {
    try {
      const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
      const res = await voiceController.assetsList(projectItem.id);
      if (res.code === 0) {
        const { projectVoices, userVoices, aiVoices } = res.data;
        if (projectVoices) {
          projectVoices.forEach((item) => (item.playFlag = false));
          setProjectVoiceList(projectVoices);
        } else {
          setProjectVoiceList([]);
        }

        if (userVoices) {
          userVoices.forEach((item) => (item.playFlag = false));
          setMyVoiceList(userVoices);
        } else {
          setMyVoiceList([]);
        }
        if (aiVoices) {
          aiVoices.forEach((item) => (item.playFlag = false));
          setAiVoiceList(aiVoices);
        } else {
          setAiVoiceList([]);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, [useVoiceItem, selectSpeakerItem]);

  // useEffect(() => {
  //   fetchList();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [projectDetail.voiceNumber]);
  const fetchList = async (val) => {
    await getlist(val);
  };
  // 处理弹窗显示和关闭事件的副作用
  useEffect(() => {
    // 如果showNotification为true，显示对话框
    const obj = {
      ...selectSpeakerItem,
      type: selectSpeakerItem.voiceType,
      number: selectSpeakerItem.voiceNumber,
      name: selectSpeakerItem.voiceName,
    };
    setSelectVoiceItem(obj);
    if (showVoiceLost) {
      setTabActive(selectSpeakerItem?.voiceType ?? 2);
      getlist();
      PopUpRef.current.show();
    } else {
      PopUpRef.current.close();
    }
    const dialogElement = PopUpRef.current;
    // 如果对话框元素存在，添加关闭事件监听器
    if (dialogElement) {
      dialogElement.addEventListener('close', handleClose);
    }

    // 清理函数
    return () => {
      // 如果对话框元素存在，移除关闭事件监听器
      if (dialogElement) {
        dialogElement.removeEventListener('close', handleClose);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showVoiceLost, selectSpeakerItem]);
  useEffect(() => {
    if (!updateTimestamp) return;
    if (showVoiceLost) {
      getlist();
    }
    if (currentItem.number === useVoiceItem?.number) {
      setUseVoiceItem(currentItem);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTimestamp]);
  useEffect(() => {
    console.log(voiceDeleteTime, 'voiceDeleteTimevoiceDeleteTimevoiceDeleteTime');

    if (!voiceDeleteTime) return;
    if (showVoiceLost) {
      getlist();
    }
    if (currentItem.number === selectSpeakerItem?.voice?.number) {
      setUseVoiceItem({});
      setSelectVoiceItem({});
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [voiceDeleteTime, selectSpeakerItem]);
  useWebSocket(
    MessageEventType.CLONE_VOICE,
    useCallback(() => {
      fetchList('clone_voice');
    }, [useVoiceItem]),
  );
  useEffect(() => {
    setMyVoiceList((prev) => prev.map((item) => ({ ...item, playFlag: false })));
    setProjectVoiceList((prev) => prev.map((item) => ({ ...item, playFlag: false })));
    setAiVoiceList((prev) => prev.map((item) => ({ ...item, playFlag: false })));
  }, [tabActive]);
  const changeName = (name) => {
    const newName = 'voice_' + name.split('_').pop();
    return newName;
  };
  const handleChangeVoice = async () => {
    window.onClickGATrackEvent('voice-change-confirm');
    console.log(selectSpeakerItem, selectVoiceItem, 'selectSpeakerItemselectSpeakerItem');

    try {
      await projectController.editSpeaker({
        id: selectSpeakerItem.id,
        body: {
          voiceNumber: selectVoiceItem.number,
          voiceType: selectVoiceItem.type,
          voiceName: !selectVoiceItem?.nameModify
            ? changeName(selectVoiceItem.name)
            : selectVoiceItem.name,
        },
      });
    } catch (error) {
      console.log(error);
    }
    console.log(selectSpeakerItem, 'selectSpeakerItemselectSpeakerItem');
    getSpeakerList();
  };
  const getSpeakerList = async () => {
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      const res = await projectController.getSpeakerList({
        projectId: projectItem.id,
      });
      if (res.code == 0) {
        setSpeakerList(res.data);
      }
    } catch (error) {
      console.log(error);
    }
    setChangeVoiceEditSentence({
      item: selectSpeakerItem,
      date: Date.now(),
    });
    handleClose();
  };

  const createDom = () => {
    if (tabActive === 0 || tabActive === 2) {
      return null;
    }
    if (userSubscription?.voiceCount >= 20) {
      return <div className="clones_text">You have reached the limit of voice clones</div>;
    } else {
      return null;
    }
  };
  return (
    <div className="voice_list_box">
      <EseClosePopup close={handleClose} />
      <dialog ref={PopUpRef} className="modal">
        <div className="modal-box min-w-[920px]">
          <form method="dialog">
            <button className="btn btn-sm btn-circle btn-ghost absolute right-[20px] top-[20px] close_icon_btn">
              <Icon name="icon-close-stroke" />
            </button>
          </form>
          <div className="voice_list_main">
            <div className="title">{t('As_Edit_EditVoice')}</div>
            <div className="tab_box">
              {mode !== 'narration' && (
                <div
                  className={`tab ${tabActive === 0 ? 'tab_active' : ''}`}
                  onClick={() => {
                    window.onClickGATrackEvent('voice-tab-project');
                    setTabActive(0);
                  }}>
                  {t('As_Edit_Changevoiceoption1')}
                </div>
              )}
              <div
                className={`tab ${tabActive === 2 ? 'tab_active' : ''}`}
                onClick={() => {
                  window.onClickGATrackEvent('voice-tab-aivoices');
                  setTabActive(2);
                }}>
                {t('As_Edit_Changevoiceoption2')}
              </div>
              <div
                className={`tab ${tabActive === 1 ? 'tab_active' : ''} my_voices`}
                onClick={() => {
                  window.onClickGATrackEvent('voice-tab-myvoices');
                  setTabActive(1);
                }}>
                {t('As_Edit_MyVoice334')}
                {/* <div
                  className={`badge  voices_num ${myVoiceList?.length === userSubscription?.voiceCountQuota ? 'badge-error' : 'badge-accent'}`}>
                  {myVoiceList?.length}/{userSubscription?.voiceCountQuota}
                </div> */}
              </div>
            </div>
            <div className="tab_main">
              {tabActive === 0 &&
                (projectVoiceList?.length ? (
                  <ItemCard list={projectVoiceList} type="projectVoice" />
                ) : (
                  <EmptyVoiceList />
                ))}
              {
                tabActive === 1 &&
                  (myVoiceList?.length ? (
                    <ItemCard list={myVoiceList} type="clonedVoice" />
                  ) : (
                    <EmptyVoiceList />
                  ))
                // <ItemCard list={myVoiceList} />
              }
              {tabActive === 2 &&
                (aiVoiceList?.length ? <AiItemCard list={aiVoiceList} /> : <EmptyVoiceList />)}
            </div>
            <div className="pop_btm">
              {createDom()}
              {JSON.stringify(selectVoiceItem) === '{}' ? (
                <button className="btn btn-primary btn_none">
                  {t('As_Edit_Changevoiceconfirm')}
                </button>
              ) : (
                <button className="btn btn-primary" onClick={handleChangeVoice}>
                  {t('As_Edit_Changevoiceconfirm')}
                </button>
              )}
            </div>
          </div>
        </div>
      </dialog>
    </div>
  );
}
// 定义ItemCard组件，用于显示语音列表项
function ItemCard({ list, type }) {
  const { t } = useTranslation();
  const {
    showVoiceLost,
    showNotification,
    tabActive,
    setShowChangeNameModal,
    setCurrentItem,
    // setShowDeleteModal,
    pupUpTime,
    selectVoiceItem,
    setSelectVoiceItem,
    setShowNotification,
    setShowVoiceList,
    userSubscription,
    speakerColorList,
  } = useContext(EditContext);

  const { setIsOpen } = useDrawer();

  const handleCreateVoice = () => {
    if (list?.length === userSubscription?.voiceCountQuota) {
      setShowVoiceList(false);
      setIsOpen(true);
    } else {
      setShowNotification(true);
    }
  };
  // 当前正在播放的音频索引
  const [playingItem, setPlayingItem] = useState({});
  // 音频元素的引用
  const audioRef = useRef(null);
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.removeEventListener('ended', handleAudioEnded);
    }
    setPlayingItem({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pupUpTime, tabActive]);
  useEffect(() => {
    // 清理函数，用于组件卸载时移除事件监听器
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.removeEventListener('ended', handleAudioEnded);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePlayPause = (item) => {
    if (item.status === 0) return;
    if (playingItem?.number === item.number) {
      item.playFlag = false;
      audioRef.current.pause();
      setPlayingItem(null);
    } else {
      list.filter((item) => {
        item.playFlag = false;
      });
      item.playFlag = true;
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.removeEventListener('ended', handleAudioEnded);
      }
      audioRef.current = new Audio(item.sampleUrl);
      audioRef.current.addEventListener('ended', handleAudioEnded);
      // audioRef.current.load();
      audioRef.current.play();
      setPlayingItem(item);
    }
  };
  useEffect(() => {
    if (!showVoiceLost || showNotification) {
      list.filter((item) => {
        item.playFlag = false;
      });
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.removeEventListener('ended', handleAudioEnded);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showVoiceLost, showNotification]);
  const handleAudioEnded = () => {
    list.filter((item) => {
      item.playFlag = false;
    });
    setPlayingItem(null);
  };
  const handleOpenEditName = (val) => {
    setCurrentItem(val);
    list.filter((item) => {
      item.playFlag = false;
    });
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.removeEventListener('ended', handleAudioEnded);
    }
    setShowChangeNameModal(true);
  };
  const changeName = (name) => {
    const newName = 'voice_' + name.split('_').pop();
    return newName;
  };
  // 渲染语音列表
  return (
    <div className="item_card">
      {list?.length < userSubscription?.voiceCountQuota && tabActive === 1 && (
        <div className="card_box new_voice" onClick={handleCreateVoice}>
          <img src={ImgAdd} alt="" />
          <div className="text">
            {/* Clone New Voice */}
            {t('As_Clone_NewVoice')}
          </div>
        </div>
      )}
      {list.map((item, index) => (
        <div
          key={index}
          className={`card_box ${tabActive === 1 ? 'card_hover' : ''} ${selectVoiceItem?.number === item.number && selectVoiceItem?.type !== 2 ? 'card_active' : ''}`}
          onClick={() => {
            if (item.status === 0) return;

            setSelectVoiceItem(item);
          }}>
          <div className="card_top">
            <div className="playimg_box" onClick={() => handlePlayPause(item)}>
              {/* <img src={item.playFlag ? ImgPlay : ImgPause} alt="" /> */}
              {item.status === 0 ? (
                <div className="playimg_loading_bg">
                  <span className="loading loading-spinner text-primary"></span>
                </div>
              ) : (
                <img src={item.playFlag ? ImgPlay : ImgPause} alt="" />
              )}
            </div>
            <div className="card_name">
              <div className="text_box">
                <div
                  className="text"
                  style={{
                    color: type === 'projectVoice' ? speakerColorList[index]?.bgColor : '',
                  }}>
                  {type === 'projectVoice' && !item.nameModify ? changeName(item.name) : item.name}
                </div>
                {item.playFlag && <img src={PlayvoiceImg} alt="" className="playvoice_img" />}
              </div>
              {/* <div className="time">{formatDateTime(item.gmtCreated)}</div> */}
              {item.status === 0 ? (
                <div className="cloning">
                  {/* Voice cloning */}
                  {t('As_Clone_Cloning')}
                  <span className="spot_list cloneing_spot">
                    <span className="spot">·</span>
                    <span className="spot">·</span>
                    <span className="spot">·</span>
                  </span>
                </div>
              ) : (
                <div className="time">{formatDateTime(item.gmtCreated)}</div>
              )}
            </div>
          </div>
          <div className="card_btm">
            <button
              className="btn btn-ghost btn-sm btn_rename"
              onClick={() => {
                handleOpenEditName(item);
              }}>
              <Icon name="icon-edit" className="btn_icon" />
              {/* Rename */}
              {t('As_ProjectManage_Rename')}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

// 定义ItemCard组件，用于显示语音列表项
function AiItemCard({ list }) {
  const {
    showVoiceLost,
    showNotification,
    tabActive,
    pupUpTime,
    selectVoiceItem,
    setSelectVoiceItem,
  } = useContext(EditContext);
  // 当前正在播放的音频索引
  const [playingItem, setPlayingItem] = useState({});
  // 音频元素的引用
  const audioRef = useRef(null);
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.removeEventListener('ended', handleAudioEnded);
    }
    setPlayingItem({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pupUpTime, tabActive]);
  useEffect(() => {
    // 清理函数，用于组件卸载时移除事件监听器
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.removeEventListener('ended', handleAudioEnded);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePlayPause = (item) => {
    if (item.status === 0) return;
    if (playingItem?.number === item.number) {
      item.playFlag = false;
      audioRef.current.pause();
      setPlayingItem(null);
    } else {
      list.filter((item) => {
        item.playFlag = false;
      });
      item.playFlag = true;
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.removeEventListener('ended', handleAudioEnded);
      }
      audioRef.current = new Audio(item.sampleUrl);
      audioRef.current.addEventListener('ended', handleAudioEnded);
      // audioRef.current.load();
      audioRef.current.play();
      setPlayingItem(item);
    }
  };
  useEffect(() => {
    if (!showVoiceLost || showNotification) {
      list.filter((item) => {
        item.playFlag = false;
      });
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.removeEventListener('ended', handleAudioEnded);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showVoiceLost, showNotification]);
  const handleAudioEnded = () => {
    list.filter((item) => {
      item.playFlag = false;
    });
    setPlayingItem(null);
  };
  // 渲染语音列表
  return (
    <div className="item_card_ai">
      {list.map((item, index) => (
        <div
          key={index}
          className={`card_box ${selectVoiceItem?.number === item.number && selectVoiceItem?.type === 2 ? 'card_active' : ''}`}
          onClick={() => {
            if (item.status === 0) return;
            setSelectVoiceItem(item);
          }}>
          <div className="playimg_box">
            <div className="icon_container">
              <img className="voice_img" src={item.image} alt="" />
              <div className="play_img" onClick={() => handlePlayPause(item)}>
                <img
                  className="play_icon"
                  src={item.playFlag ? ImgAiVoicePlay : ImgAiVoicePause}
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="card_right">
            <div className="text_box">
              <div className="text">{item.name}</div>
              {item.playFlag && <img src={PlayvoiceImg} alt="" className="playvoice_img" />}
            </div>
            <div className="text_language">
              <span className="language">{item.language}</span>
              {item.gender === 1 && <span>Male</span>}
              {item.gender === 0 && <span>Female</span>}
            </div>
            <div className="badge_box">
              {/* <div className="badge badge-ghost">{item.label}</div> */}
              <div className="badge badge-ghost">{item.purpose || item.label}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

// 定义EmptyVoiceList组件，用于显示空列表状态
function EmptyVoiceList() {
  const { tabActive } = useContext(EditContext);
  const { t } = useTranslation();
  return (
    <div className="empty_box">
      {/* {tabActive !== 1 && ( */}
      <div className="empty_img">
        <img src={Imgnolist} alt="" />
        <div className="empty_text">
          {tabActive === 0 && t('As_Edit_Changevoices3')}
          {tabActive === 1 && t('As_Edit_Changevoices2')}
          {tabActive === 2 && t('As_Edit_Changevoices1')}
        </div>
      </div>
      {/* )} */}
      {/* {tabActive === 1 && (
        <div className="new_voice" onClick={handleCreateVoice}>
          <img src={ImgAdd} alt="" />
          <div className="text">Clone New Voice</div>
        </div>
      )} */}
    </div>
  );
}
